export default __webpack_public_path__ + "static/media/doc.57c58b93.svg";